import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import { useAuth } from '../contexts/auth/hooks';

export default function WelcomeBoot() {
  const navigate = useNavigate();
  const { user, hasAppUser, business, refreshBusiness } = useAuth();
  const timerRef = useRef<number | null>(null);

  // כללי ניווט בסיסי
  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
      return;
    }
    if (hasAppUser === false) {
      navigate('/register/business', { replace: true });
      return;
    }
    if (hasAppUser === true && business) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, hasAppUser, business, navigate]);

  // פולינג עד שה־business מוכן
  useEffect(() => {
    let cancelled = false;

    const poll = async () => {
      if (cancelled) return;
      try {
        await refreshBusiness(user);
      } catch {
        // נתעלם משגיאות רגעיות
      }
      timerRef.current = window.setTimeout(poll, 800);
    };

    // נתחיל רק אם יש user ויש AppUser אבל עוד אין business
    if (user && hasAppUser === true && !business) {
      poll();
    }

    return () => {
      cancelled = true;
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, hasAppUser, business]);

  return <LoadingScreen autoNavigate={false} />;
}
